import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ZkTInputStatus } from '@zenklub/ng-ui/component/input/input-status/input-status.interface';

import {
	ZkECurrencyDisableInput,
	ZkECurrencyInputButtonVariants,
	ZkECurrencyInputVariants,
} from './currency-input.interface';

@Component({
	selector: 'zk-currency-input',
	templateUrl: './currency-input.component.html',
	styleUrls: ['./currency-input.component.scss'],
})
export class ZkCurrencyInput {
	@Input() variant: ZkECurrencyInputVariants = 'enabled';
	@Input() buttonVariant: ZkECurrencyInputButtonVariants = 'enabled';
	@Input() buttonLabel = 'Alterar';
	@Input() value: number;
	@Input() placeholder = '';
	@Input() status: ZkTInputStatus = 'default';
	@Input() message: string;
	@Input() currency = 'R$';
	@Input() disableInput: ZkECurrencyDisableInput = false;

	@Output() clickButton = new EventEmitter<number>();
	@Output() change = new EventEmitter<number>();

	onClick(): void {
		this.clickButton.emit(this.value);
	}

	onChange(): void {
		this.change.emit(this.value);
	}
}
